var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageRoundSwapHoriz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13979 11.8601L3.35979 14.6501C3.16979 14.8501 3.16979 15.1601 3.35979 15.3601L6.13979 18.1501C6.44978 18.4701 6.98978 18.2401 6.98978 17.8001V16.0001H12.9998C13.5498 16.0001 13.9998 15.5501 13.9998 15.0001C13.9998 14.4501 13.5498 14.0001 12.9998 14.0001H6.98978V12.2101C6.98978 11.7601 6.44978 11.5401 6.13979 11.8601ZM20.6498 8.65009L17.8698 5.86009C17.5598 5.54009 17.0198 5.77009 17.0198 6.21009V8.00009H10.9998C10.4498 8.00009 9.99979 8.45009 9.99979 9.00009C9.99979 9.55009 10.4498 10.0001 10.9998 10.0001H17.0098V11.7901C17.0098 12.2401 17.5498 12.4601 17.8598 12.1401L20.6398 9.35009C20.8398 9.16009 20.8398 8.84009 20.6498 8.65009Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageRoundSwapHoriz);
export default __webpack_public_path__ + "static/media/language_round-swap-horiz.027f68d9e4eaf94b2acc612280cd936c.svg";
export { ForwardRef as ReactComponent };